<app-traitement-data titre="SPO2 sans O2" [sousTitre]="patient!.tableauDeBord?.spo2SansO2?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.spo2SansO2?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.spo2SansO2?.value ?? 'Pas de donnée' }}
</app-traitement-data>